import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent } from '../ui/dialog';
import { Button } from '../ui/button';
import { authApi } from '../../lib/api';
import { UserPlus, Sparkles, Eye, ArrowRight, Gift } from 'lucide-react';

const steps = [
  {
    icon: UserPlus,
    title: 'Hasta Ekleyin',
    desc: 'Hastalar sayfasından yeni bir hasta kaydı oluşturun.',
    color: 'text-blue-600 bg-blue-100',
  },
  {
    icon: Sparkles,
    title: '4K Üretim Başlatın',
    desc: 'Ultrason görüntüsü yükleyip AI ile 4K fetal yüz oluşturun.',
    color: 'text-amber-600 bg-amber-100',
  },
  {
    icon: Eye,
    title: 'Sonucu Görün',
    desc: 'Sonucu hastanızla kolayca paylaşın.',
    color: 'text-emerald-600 bg-emerald-100',
  },
];

export const OnboardingModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);

  const handleStart = async () => {
    try { await authApi.completeOnboarding(); } catch (_) {}
    onClose();
    navigate('/doctor/patients');
  };

  const isLast = current === steps.length - 1;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden" data-testid="onboarding-modal">
        {/* Header */}
        <div className="bg-gradient-to-br from-[#5A67D8] to-[#4338CA] p-6 text-white text-center">
          <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-3">
            <Gift className="w-6 h-6" />
          </div>
          <h2 className="text-xl font-bold">NeoBreed AI'ye Hoş Geldiniz!</h2>
          <p className="text-sm text-white/80 mt-1">1 ücretsiz deneme hakkınız hazır</p>
        </div>

        {/* Steps */}
        <div className="p-6">
          <div className="space-y-4">
            {steps.map((step, i) => {
              const Icon = step.icon;
              const active = i === current;
              return (
                <div
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`flex items-start gap-3 p-3 rounded-lg cursor-pointer transition-all ${
                    active ? 'bg-slate-50 ring-1 ring-[#5A67D8]/30' : 'opacity-60'
                  }`}
                >
                  <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${step.color}`}>
                    <Icon className="w-4 h-4" />
                  </div>
                  <div>
                    <p className="font-semibold text-sm text-slate-800">{step.title}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{step.desc}</p>
                  </div>
                  <div className="ml-auto flex-shrink-0 mt-1">
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center text-xs font-bold ${
                      active ? 'border-[#5A67D8] text-[#5A67D8]' : 'border-slate-300 text-slate-300'
                    }`}>
                      {i + 1}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex gap-3 mt-6">
            {!isLast ? (
              <Button
                onClick={() => setCurrent(c => c + 1)}
                className="w-full bg-[#5A67D8] hover:bg-[#4338CA] text-white"
                data-testid="onboarding-next-btn"
              >
                Devam <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            ) : (
              <Button
                onClick={handleStart}
                className="w-full bg-emerald-600 hover:bg-emerald-700 text-white"
                data-testid="onboarding-start-btn"
              >
                Hemen Başla
              </Button>
            )}
          </div>

          <button
            onClick={handleStart}
            className="w-full text-center text-xs text-slate-400 hover:text-slate-600 mt-3 transition-colors"
          >
            Atla
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
